
import SsrCarousel from 'vue-ssr-carousel'
export default {
  name: 'AccreditationSection',
  components:{SsrCarousel},
  data() {
    return {
      accreditations: [
        {
          id: 1,
          logo: '/TQUK.svg',
          description: 'Ofqual (The Office of Qualifications and Examinations Regulation) is responsible for regulating education standards, certifications and exams in England and Wales.'
        },
        {
          id: 2,
          logo: '/DEAC.svg',
          description: 'The DEAC (Distance Education Accrediting Commission) was founded in 1926 and accredits distance learning providers across the USA and internationally.'
        },
        {
          id: 3,
          logo: '/AQC.svg',
          description: 'Recognised by the United States Department of Education and the Council for Higher Education Accreditation, the DEAC awards AQC (Approved Quality Curriculum) status only to providers who meet their stringent standards.'
        },
        {
          id: 4,
          logo: '/BAC.svg',
          description: 'The British Accreditation Council is an internationally recognised body and has provided globally respected accreditation services for over three decades.'
        },
        {
          id: 5,
          logo: '/SQA.svg',
          description: 'The SQA is the national body in Scotland responsible for the development, accreditation, assessment and certification of qualifications other than degrees.'
        },
        {
          id: 6,
          logo: '/CPD-Member-TEFL-org.svg',
          description: 'The CPD Certification Service is an independent organisation with over 30 years\' experience providing CPD accreditation'
        }
      ],
      benefits: [
        {
          id: 1,
          text: 'A proven, up-to-date curriculum that meets industry standards.'
        },
        {
          id: 2,
          text: 'Courses delivered by expert tutors who know what it takes to succeed in real classrooms.'
        },
        {
          id: 3,
          text: 'A qualification that employers trust – increasing your chances of landing jobs worldwide.'
        }
      ],
      reviews: [
        {
          id: 2,
          date: '2 days ago',
          title: 'Best on the market',
          text: 'I love this product because the support is great. Please...',
          author: 'Worldtraveler'
        },
        {
          id: 3,
          date: '2 days ago',
          title: 'Best on the market',
          text: 'I love this product because the support is great. Please...',
          author: 'Worldtraveler'
        },
        {
          id: 4,
          date: '2 days ago',
          title: 'Best on the market',
          text: 'I love this product because the support is great. Please...',
          author: 'Worldtraveler'
        }
      ],
      certificateCards: [
        {
          id: 1,
          title: 'Lifetime Access to Our Jobs Centre',
          description: 'Find teaching roles in 80+ countries, updated regularly.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>'
        },
        {
          id: 2,
          title: 'Connection to Global Partners',
          description: 'Access exclusive jobs through our global network, with employers who trust the TEFL Org.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg>'
        },
        {
          id: 3,
          title: 'Job Search Support',
          description: 'Make your job search easier with tailored resources from resume advice to interview tips. We\'re here to help – even after you\'re certified.',
          icon: '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polygon points="10 8 16 12 10 16 10 8"/></svg>'
        }
      ]
    }
  },
  methods: {
    scrollCarousel(amount) {
      if (this.$refs.reviewsCarousel) {
        this.$refs.reviewsCarousel.scrollBy({
          left: amount,
          behavior: 'smooth'
        })
      }
    }
  }
}
